<template>
  <div>
    <CubePage type="catcheck-view" title="供应商首页" :backurl="'/my'">
      <div slot="content" class="content">
        <div class="topbox">
          <div class="title">
            <span>￥</span>
            <span class="fontbig">{{listObj.pay_price}}</span>
          </div>
          <div class="topbox-items">
            <div class="topbox-item">
              <p>今日售票数</p>
              <p>{{listObj.order_count}}</p>
            </div>
            <div class="border"></div>
            <div class="topbox-item">
              <p>今日核销量/金额</p>
              <p>{{listObj.receipt_count}} / {{listObj.receipt_price}}</p>
            </div>
            <div class="border"></div>
            <div class="topbox-item">
              <p>退票数/金额</p>
              <p>{{listObj.refund_count}} / {{listObj.refund_price}}</p>
            </div>
          </div>
        </div>
        <div class="conten-box">
          <div class>
            <!-- 系统公告  -->
            <van-swipe
              style="height: 100px;"
              :autoplay="3000"
              :vertical="true"
              :show-indicators="false"
            >
              <van-swipe-item v-for="(itemlist, key) in list" :key="key">
                <template v-for="(item, index) in itemlist">
                  <div :key="index" class="text-content van-ellipsis" @click="gotourl(item)">
                    <span>{{ item.title}}</span>
                  </div>
                </template>
              </van-swipe-item>
            </van-swipe>
          </div>
          <div class="title">
            <span>账号已开通功能</span>
          </div>
          <div class>
            <van-grid clickable :column-num="3">
              <van-grid-item text="产品管理" to="supplier_product">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="chanpin"
                    class-prefix="icon"
                    color="#55aa7f"
                    style="font-weight: 600;"
                    size="28"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="订单管理" to="supplier_order">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="dingdanjihe"
                    class-prefix="icon"
                    size="28"
                    color="#ffaa7f"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="门票核销" to="wirteoff">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="hexiao"
                    class-prefix="icon"
                    size="28"
                    color="#ff00ff"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="退单管理 " to="supplier_orderTD">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="tuidanguanli"
                    class-prefix="icon"
                    size="28"
                    color="#ff0000"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="数据分析" to="supplier_data">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="shujufenxi"
                    class-prefix="icon"
                    size="28"
                    color="#55aaff"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="店主管理" to="supplier_mar">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="shanghuguanli"
                    class-prefix="icon"
                    size="28"
                    color="#ffaaff"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="分销商账户" to="supplier_user">
                <template #icon>
                  <van-icon
                    class="iconfont"
                    name="RectangleCopy"
                    class-prefix="icon"
                    size="28"
                    color="#00aa00"
                    style="font-weight: 600;"
                  />
                </template>
              </van-grid-item>
              <van-grid-item text="推荐二维码" @click="onShowQr">
                <template #icon>
                  <van-icon name="qr" size="28" color="#55aa7f" style="font-weight: 600;"/>
                </template>
              </van-grid-item>
            </van-grid>
          </div>
        </div>
      </div>
    </CubePage>
    <van-popup v-model="qrShow">
      <van-image :src="qrImg" width="300"/>
    </van-popup>
    <van-popup
      v-for="(item,i) in ggShow1" :key="i"
      :overlay="i==0"
      v-model="item.show"
      class="gg-popup"
      @close="ggClose1(i)"
      :close-on-click-overlay="false"
      style="width: 70%;"
    >
      <div class="cc-qq">
        <div class="title" v-if="item.title">
          <p>{{item.title}}</p>
        </div>
        <div class="gg-content" v-if="item.content">
          <div v-html="item.content"></div>
        </div>
      </div>
      <div class="qq-clode">
        <van-icon name="close" @click="ggClose1(i)"/>
      </div>
    </van-popup>
  </div>
</template>

<script>
import CubePage from "../../TP/cube-page.vue";
import CubeView from "@/components/TP/cube-view";
import * as util from "@/utils/network";
import {redirect} from "@/utils/network";
export default {
  components: {
    CubePage,
    CubeView
  },
  data() {
    return {
      listObj: {},
      qrShow: false,
      ggShow: false,
      qrImg: null,
      ggObj: null,
      list: [],
      ggShow1: []
    };
  },
  created() {
    // this.ggShow = !this.$store.getters.getgGSupPage
    this.getGg();
    this.getData();
	this.getSysNotice();
  },
  methods: {
    //二维码
    onShowQr() {
      let that = this;
      that.qrImg = null;
      var url = "/addons/litestore/api.supplier/qrcode";
      let id = that.storeid ? that.storeid : this.$store.getters.getShop;
      //这里直接调用网络接口
      util.get(
        url,
        {
          sid: id
        },
        function(result) {
          that.qrImg = result.data.dtb_qrcode;
          that.qrShow = true;
        }
      );
    },
    ggClose1(i) {
      console.log(this.ggShow1);
      this.ggShow1[i].show = false;
    },
    async getGg() {
      var url = "/addons/litestore/api.index/notice";
      let that = this;
      that.ggShow1 = [];
      //这里直接调用网络接口
      await util.get(url, {
		  type:1,
		  place:102
	  }, function(res) {
        // that.ggShow = false
        // if (res.data) {
        // 	that.ggShow = true
        // 	that.ggObj = res.data
        // }
        res.data.forEach(item => {
          that.ggShow1.push({
            title: item.title,
            show: true,
            content: item.content
          });
        });
      });
    },
    // 获取公告
    getSysNotice() {
      let that = this;
      var url = "/addons/litestore/api.index/getSysNotice";
      //这里直接调用网络接口
      util.get(
        url,
        {
          place: 102
        },
        function(result) {
          that.list = result;
        }
      );
    },
    // 公告跳转
    gotourl(item) {
      console.log(item);
      if (item.url) {
        window.location.href = item.url;
      } else {
        this.$router.push({ path: "about", query: { id: item.id } });
      }
    },
    ggClose() {
      // this.$store.commit('setgGPage', true)
    },
    async getData() {
      let that = this;
      var url = "/addons/litestore/api.supplier/index";
      //这里直接调用网络接口
      await util.post(url, {}, function(result) {
        that.listObj = result.data;
      },function () {
          redirect('my');
      });
    }
  }
};
</script>
<style lang="less" scoped="scoped">
.gg-popup {
  background: transparent;
  min-width: 70%;
  max-width: 90%;

  .cc-qq {
    border-radius: 10px;
    background-color: #fff;

    .title {
      padding: 8px 10px;
      font-size: 14px;
      background-color: #ff8a3a;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      color: #fff;

      p {
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .van-row {
      padding: 0 15px;
      margin-top: 10px;

      .van-col--12 {
        .van-image {
          height: 156px;
        }
      }

      .van-col--8 {
        .van-image {
          height: 102px;
        }
      }
    }

    .imgs {
      display: flex;

      .van-image + .van-image {
        margin-left: 10px;
      }
    }

    .gg-content {
      //max-height: 480px;
      height: 400px;
      padding: 15px;
      overflow-x: hidden;
      overflow-y: scroll;
      font-size: 13px;
      line-height: 22px;
    }
  }

  .qq-clode {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;

    .van-icon {
      color: #fff;
      font-size: 28px;
    }
  }
}

.content {
  padding: 0 8px;
}

.topbox {
  background-color: #55aa7f;
  padding: 10px;
  color: #ffffff;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;

  .title {
    line-height: 45px;
    text-align: center;

    .fontbig {
      font-size: 30px;
    }
  }

  .topbox-items {
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;

    p {
      padding: 3px 0;
      font-size: 14px;
    }

    .border {
      width: 0.5;
      height: 70%;
      border: 0.5px solid #ffffff;
      background-color: #ffffff;
    }
  }
}

.conten-box {
  padding-bottom: 200px;
  margin: 15px 0;
  border-radius: 15px;
  background-color: #ffffff;

  .title {
    font-size: 14px;
    line-height: 50px;
    padding: 0 15px;
    color: #949494;
    border-bottom: 2px solid #fafafa;
  }
}

.text-content {
  font-size: 14px;
  color: #333;
  padding-left: 15px;
  margin-bottom: 5px;
}

/deep/ .van-swipe {
  margin: 0;
  padding: 15px;
  border-radius: 8px;
}

/deep/ .van-swipe__indicator {
  background-color: #333;
}
</style>
